import React from 'react';
import Assets from '../../Assets';

class DiagramCanvasPortal extends React.Component {
    constructor(props) {
        super(props)

        this.el = document.getElementById('diagram-canvas-portal')

        if (!this.el) {
            this.el = document.createElement('div')
            this.el.setAttribute('id', 'diagram-canvas-portal')
            document.body.appendChild(this.el)
        }
    }

    render() {
        if (this.props.usePortal) {
            return ReactDOM.createPortal(
                this.props.children,
                this.el
            )
        }

        return this.props.children
    }
}

export default class EditorDiagramCard extends React.Component {
    minScale = 0.9;

    constructor(props) {
        super(props)

        this.state = {
            canvasTranslateX: 0,
            canvasTranslateY: 0,
            canvasTransformOriginX: 50,
            canvasTransformOriginY: 50,
            canvasScale: this.minScale,
            isFullscreen: false
        }

        this.canUpdateState = true
        this.mouseOver = false
        this.mouseDown = false
        this.lastMouseX = 0
        this.lastMouseY = 0

        this.diagramRef = null
    }

    componentDidMount() {
        window.addEventListener('keyup', this.onKeyUp)
        window.addEventListener('mouseup', this.onMouseUp)
    }

    onMouseDown = e => {
        e.preventDefault()

        let rect = this.diagramRef.getBoundingClientRect()

        this.mouseDown = true
        this.lastMouseX = e.clientX - rect.left
        this.lastMouseY = e.clientY - rect.top
    }

    onMouseMove = e => {
        this.dragHandler(e.clientX, e.clientY);
    }

    onMouseUp = e => {
        this.mouseDown = false
    }

    onMouseEnter = e => {
        this.mouseOver = true
    }

    onMouseLeave = e => {
        this.mouseOver = false
    }

    onTouchStart = e => {
        let rect = this.diagramRef.getBoundingClientRect()
        let touch = e.touches[0]

        this.mouseDown = true
        this.lastMouseX = touch.clientX - rect.left
        this.lastMouseY = touch.clientY - rect.top
    }

    onTouchMove = e => {
        e.preventDefault();
        this.dragHandler(e.touches[0].clientX, e.touches[0].clientY);
    }

    onTouchEnd = e => {
        this.mouseDown = false;
    }

    onWheel = e => {
        e.preventDefault()

        let targetScale = 0
        if (e.deltaY < 0) {
            targetScale = this.state.canvasScale * 1.33
        } else {
            targetScale = this.state.canvasScale / 1.33
        }

        if (targetScale < this.minScale) {
            targetScale = this.minScale
        }

        this.clampCanvasTranslate(targetScale)
        this.setState({
            canvasScale: targetScale
        })
    }

    dragHandler = (clientX, clientY) => {
        let rect = this.diagramRef.getBoundingClientRect()
        let x = clientX - rect.left
        let y = clientY - rect.top

        if (this.mouseDown) {
            let deltaX = x - this.lastMouseX
            let deltaY = y - this.lastMouseY

            let newX = this.state.canvasTranslateX + deltaX
            let newY = this.state.canvasTranslateY + deltaY

            if (this.state.isFullscreen === false) {
                let diffX = 395 - (395 * this.state.canvasScale)
                let diffY = 220 - (220 * this.state.canvasScale)

                if (-newX < diffX / 2) newX = -diffX / 2
                if (-newX > -diffX / 2) newX = diffX / 2
                if (newY < diffY / 2) newY = diffY / 2
                if (newY > -diffY / 2) newY = -diffY / 2
            }

            this.setState({
                canvasTranslateX: newX,
                canvasTranslateY: newY
            })
        }

        this.lastMouseX = x
        this.lastMouseY = y
    }

    clampCanvasTranslate(targetScale) {
        if (this.state.isFullscreen === false) {
            const defaultCanvasWidth = 395
            const defaultCanvasHeight = 220

            let newX = this.state.canvasTranslateX
            let newY = this.state.canvasTranslateY
            let diffX = defaultCanvasWidth - (defaultCanvasWidth * targetScale)
            let diffY = defaultCanvasHeight - (defaultCanvasHeight * targetScale)

            if (-newX < diffX / 2) newX = -diffX / 2
            if (-newX > -diffX / 2) newX = diffX / 2
            if (newY < diffY / 2) newY = diffY / 2
            if (newY > -diffY / 2) newY = -diffY / 2

            this.setState({
                canvasTranslateX: newX,
                canvasTranslateY: newY
            })
        }
    }

    onZoomInButtonMouseUp = e => clearInterval(this.zoomInTicker)
    onZoomInButtonClick = e => {
        e.preventDefault()
        e.stopPropagation()

        clearInterval(this.zoomInTicker)
        this.zoomInTicker = setInterval(() => {
            this.zoom(0.4, 50, 50)
        }, 100)

        this.zoom(0.4, 50, 50)
    }

    onZoomOutButtonMouseUp = e => clearInterval(this.zoomOutTicker)
    onZoomOutButtonClick = e => {
        e.preventDefault()
        e.stopPropagation()

        clearInterval(this.zoomOutTicker)
        this.zoomOutTicker = setInterval(() => {
            this.zoom(-0.4, 50, 50)
        }, 100)

        this.zoom(-0.4, 50, 50)
    }

    onFullscreenButtonClick = e => {
        this.setState({
            isFullscreen: !this.state.isFullscreen
        }, () => {
            this.setState({
                canvasTranslateY: -50
            });

            if (!this.state.isFullscreen) {
                this.reset();
            }
        })
    }

    onKeyUp = e => {
        if (this.mouseOver) {
            if (e.which === 82) {
                this.reset()
            }
        }
    }

    onResetButtonClick = e => {
        this.reset()
    }

    zoom(amount, centerX, centerY) {
        if (!this.canUpdateState) {
            return
        }

        let targetScale = Number((this.state.canvasScale + amount).toFixed(2))
        if (targetScale < this.minScale) {
            targetScale = this.minScale
        }

        this.clampCanvasTranslate(targetScale)

        this.canUpdateState = false
        this.setState({
            canvasScale: targetScale,
            canvasTransformOriginX: centerX,
            canvasTransformOriginY: centerY
        }, () => {
            this.canUpdateState = true
        })
    }

    reset() {
        this.setState({
            canvasScale: this.minScale,
            canvasTransformOriginX: 50,
            canvasTransformOriginY: 50,
            canvasTranslateX: 0,
            canvasTranslateY: 0
        })
    }

    render() {
        let canvasStyles = {
            transform: `translate3d(${this.state.canvasTranslateX}px, ${this.state.canvasTranslateY}px, 0) scale(${this.state.canvasScale})`,
            transformOrigin: `${this.state.canvasTransformOriginX}% ${this.state.canvasTransformOriginY}%`
        }

        if (this.mouseDown) {
            canvasStyles.transition = 'none';
        }

        return (
            <div className="card">
                <DiagramCanvasPortal usePortal={this.state.isFullscreen}>
                    <div
                        className={`card-body configuration-editor-diagram ${this.state.isFullscreen ? 'fullscreen' : ''}`}
                        onMouseDown={this.onMouseDown}
                        onMouseMove={this.onMouseMove}
                        onMouseUp={this.onMouseUp}
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}
                        onTouchStart={this.onTouchStart}
                        onTouchEnd={this.onTouchEnd}
                        ref={r => {
                            if (r !== null) {
                                this.diagramRef = r;
                                this.diagramRef.removeEventListener('wheel', this.onWheel);
                                this.diagramRef.addEventListener('wheel', this.onWheel);
                                this.diagramRef.removeEventListener('touchmove', this.onTouchMove);
                                this.diagramRef.addEventListener('touchmove', this.onTouchMove);
                            }
                        }}
                    >
                        <div className="configuration-editor-diagram-buttons">
                            <div className="configuration-editor-diagram-zoom-buttons">
                                <span onMouseDown={this.onZoomInButtonClick}
                                      onMouseUp={this.onZoomInButtonMouseUp}>+</span>
                                <span onMouseDown={this.onZoomOutButtonClick}
                                      onMouseUp={this.onZoomOutButtonMouseUp}>-</span>
                            </div>

                            <div className="flex-center-v">
                                <div className="configuration-editor-diagram-button"
                                     onClick={this.onFullscreenButtonClick}>
                                    <img src={Assets.diagramFullscreen}/>
                                </div>
                                <div className="configuration-editor-diagram-button"
                                     onClick={this.onResetButtonClick}>R
                                </div>
                            </div>
                        </div>

                        <div className="configuration-editor-diagram-canvas" style={canvasStyles}>
                            {this.props.diagram.toJS().map((img, idx) => (
                                <img key={idx} src={img}/>
                            ))}
                        </div>
                    </div>
                </DiagramCanvasPortal>
            </div>
        )
    }
}